'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 @module headers
 */

var castString = function castString(value) {
  return _.isString(value) ? value : String(value);
};

var normalizeName = function normalizeName(name) {

  var string = castString(name);

  if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(string)) throw new TypeError('Invalid character in header field name');

  return string.toLowerCase();
};

var Headers = function () {
  function Headers(headers) {
    var _this = this;

    _classCallCheck(this, Headers);

    this.map = {};

    if (headers instanceof Headers) _.map(headers.map, function (value, key) {
      return _this.append(key, value);
    });

    if (_.isPlainObject(headers)) _.map(headers, function (value, key) {
      return _this.append(key, value);
    });
  }

  _createClass(Headers, [{
    key: 'append',
    value: function append(name, value) {
      var _map$normalizedName, _map$normalizedName2;

      var normalizedName = normalizeName(name);

      if (!_.has(this.map, normalizedName)) this.map[normalizedName] = [];

      if (_.isArray(value)) (_map$normalizedName = this.map[normalizedName]).push.apply(_map$normalizedName, _toConsumableArray(_.map(value, castString)));

      if (_.isString(value) && _.includes(value, ',')) (_map$normalizedName2 = this.map[normalizedName]).push.apply(_map$normalizedName2, _toConsumableArray(value.split(',')));

      if (!_.isArray(value) && !_.includes(value, ',')) this.map[normalizedName].push(castString(value));
    }
  }, {
    key: 'delete',
    value: function _delete(name) {

      this.map = _.omit(this.map, name);
    }
  }, {
    key: 'get',
    value: function get(name) {

      var values = this.map[normalizeName(name)];

      return values ? values[0] : null;
    }
  }, {
    key: 'getAll',
    value: function getAll(name) {

      return this.map[normalizeName(name)] || [];
    }
  }, {
    key: 'has',
    value: function has(name) {

      return _.has(this.map, normalizeName(name));
    }
  }, {
    key: 'set',
    value: function set(name, value) {

      this.map[normalizeName(name)] = [castString(value)];
    }
  }, {
    key: 'entries',
    value: function entries() {

      throw new Error('Method has not been implemented by farfetchd yet');
    }
  }, {
    key: 'keys',
    value: function keys() {

      throw new Error('Method has not been implemented by farfetchd yet');
    }
  }, {
    key: 'values',
    value: function values() {

      throw new Error('Method has not been implemented by farfetchd yet');
    }
  }]);

  return Headers;
}();

exports.default = Headers;